module.exports = __webpack_public_path__ + "img/btn.0f2fb7c1.png";